import {ZendeskCategory, ZendeskCategoryName} from '../zendesk/zendesk.enums';
import {KnowledgeCenterTab, ZendeskCategoryConfigItem} from './help.types';

const IAS_ARTICLE_ID = 9329192517012;

const zendeskCategoryConfig: ZendeskCategoryConfigItem[] = [
  {
    category: ZendeskCategory.ProductDocumentation,
    name: ZendeskCategoryName.ProductDocumentation,
    tab: KnowledgeCenterTab.ProductDocs,
  },
  {
    category: ZendeskCategory.AgencyDocumentation,
    name: ZendeskCategoryName.AgencyDocumentation,
    tab: KnowledgeCenterTab.AgencyDocs,
  },
  {
    category: ZendeskCategory.ReleaseNotes,
    name: ZendeskCategoryName.ReleaseNotes,
    tab: KnowledgeCenterTab.ReleaseNotes,
  },
  {
    category: ZendeskCategory.APIDocs,
    name: ZendeskCategoryName.APIDocs,
    tab: KnowledgeCenterTab.ExternalApi,
  },
  {
    category: ZendeskCategory.BestPractices,
    name: ZendeskCategoryName.BestPractices,
    tab: KnowledgeCenterTab.BestPractices,
  },
  {
    category: ZendeskCategory.Videos,
    name: ZendeskCategoryName.Videos,
    tab: KnowledgeCenterTab.Videos,
  },
];

export {IAS_ARTICLE_ID, zendeskCategoryConfig};
